module.exports = __webpack_public_path__ + "img/202501160301.6b3c92f9.png";